import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrap" }
const _hoisted_2 = {
  class: "modal",
  tabindex: "-1"
}
const _hoisted_3 = {
  key: 0,
  class: "modal__text"
}

import { onMounted, onUnmounted, ref } from 'vue';


const __default__ = {
  name: 'vita-modal'
}

interface Props {
  title?: string
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {}
  },
  setup(__props: any) {



const modalContent = ref<HTMLElement | null>(null);

// Обработка нажатия клавиш Enter и Tab
const handleKeyboardKeys = (event: KeyboardEvent) => {
  if (!modalContent.value) return;

  const focusableElements = Array.from(
    modalContent.value.querySelectorAll<HTMLElement>('button, input, textarea, select, a[href], [tabindex]:not([tabindex="-1"])')
  ).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);

  if (!focusableElements.length) return;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  // Проверяем, сфокусирован ли элемент внутри модалки
  if (event.key === 'Enter' && !modalContent.value.contains(document.activeElement)) {
    event.preventDefault();
    event.stopPropagation();
  }

  // Ограничение фокуса внутри модального окна
  if (event.key === 'Tab') {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

onMounted(() => {
  // Наводим фокус если только одна кнопка в модальном окне
  if (modalContent.value) {
    const buttons = modalContent.value.querySelectorAll('button');
    if (buttons.length === 1) {
      const button = buttons[0];
      button.classList.add('focus-invisible');
      button.focus();
    }
  }
  document.addEventListener('keydown', handleKeyboardKeys);
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyboardKeys);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "modal__buttons",
          ref_key: "modalContent",
          ref: modalContent
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 512)
      ])
    ])
  ]))
}
}

})